CategoriasLocalService.$inject = ['$log', '$http', '$q'];
export default function CategoriasLocalService($log, $http, $q) {
    var self = this;
    self.categorias = [];

    function getCategorias() {
        var defered = $q.defer();
        var promesa = defered.promise;

        if (self.categorias.length > 0) {
            defered.resolve(JSON.parse(JSON.stringify(self.categorias)));
        } else {
            var url = Sigo.var.path + '/api/v1/categorias';
            $http.get(url).then(function (data) {
                self.categorias = data.data;
                defered.resolve(JSON.parse(JSON.stringify(self.categorias)));
            });
        }
        return promesa;
    }

    return {
        get: getCategorias
    }
}